import {Link} from "react-router-dom";
import SvgIcon from "../../components/svg-icon";
import {useTranslation} from "react-i18next";
import stringHelper from "../../helpers/string-helper";

const CasinoListItem = props => {

    let {game, passive} = props
    const {i18n, t} = useTranslation();
    const currentLanguage = i18n.language; // Get the current language
    return (
        <div className="col-4 col-slot">
            <Link
                to={!passive && stringHelper.getLocalizedPath(currentLanguage, `/casino/games/${game.slug}`)}
                className={`slot ${passive ? 'passive' : ''}`}
            >


                <div className={`slot__cover slot__cover--${game?.color === 'no' ? 'no-layer' : ''}`}>
              <span className="slot__img">
                <img loading="lazy" src={game?.image} alt=""/>
              </span>
                    {
                        passive && <div className="slot__unavailable">
                            <SvgIcon id={'lock-pin'}/>

                            <span>
                               {t('general.not-allowed-region')}
                          </span>
                        </div>
                    }
                    <div className={`slot__title slot__title--${game?.color}`}>
                        <h3>{game?.name}</h3>
                        <span className="game-provider">{game?.provider}</span>
                    </div>
                </div>
                {/*<span className="slot__online">314 online</span>*/}
            </Link>
        </div>
    )

}

export default CasinoListItem
